module.exports = __webpack_public_path__ + "media/images/home/usecase-visio-dd3235793e6957553a42a94349db26d0.jpg";